/**
 * Copyright 2020 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export const assignMachine = `mutation AssignMachine($input: MachineAssignmentInput!) {
  assignMachine(input: $input) {
    id
  }
}`;
